import { render, staticRenderFns } from "./KegiatanPelayananFarmasi.vue?vue&type=template&id=8316fee6"
import script from "./KegiatanPelayananFarmasi.vue?vue&type=script&lang=js"
export * from "./KegiatanPelayananFarmasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8316fee6')) {
      api.createRecord('8316fee6', component.options)
    } else {
      api.reload('8316fee6', component.options)
    }
    module.hot.accept("./KegiatanPelayananFarmasi.vue?vue&type=template&id=8316fee6", function () {
      api.rerender('8316fee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananFarmasi.vue"
export default component.exports